'use strict'

module.exports = function media(md) {
  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const match = tokens[idx].attrs[0][1].match(/^media:(.*)/)
    if (match) {
      tokens[idx].attrs[0][1] =
        process.env.UPSTREAM_ASSETS_URL + '/media/' + match[1]
    }
    return self.renderToken(tokens, idx, options, env, self)
  }

  md.renderer.rules.image = (tokens, index) => {
    const token = tokens[index]
    const srcIndex = token.attrIndex('src')
    let imageUrl = token.attrs[srcIndex][1]
    const match = imageUrl.match(/^media:(.*)/)
    if (match) {
      imageUrl = process.env.UPSTREAM_ASSETS_URL + '/media/' + match[1]
    }
    const caption = md.utils.escapeHtml(token.content)
    const otherAttributes = generateAttributes(md, token)
    return `<img src="${imageUrl}" alt="${caption}"${
      otherAttributes ? ' ' + otherAttributes : ''
    }>`
  }
}

function generateAttributes(md, token) {
  const ignore = ['src', 'alt']
  const escape = ['title']

  return token.attrs
    .filter(([key]) => !ignore.includes(key))
    .map(([key, value]) => {
      const escapeAttributeValue = escape.includes(key)
      const finalValue = escapeAttributeValue
        ? md.utils.escapeHtml(value)
        : value

      return `${key}="${finalValue}"`
    })
    .join(' ')
}
